module.exports = __webpack_public_path__ + "media/icons/sort-by-up-0ef6d463.png";